export var RuntimePlatform;
(function (RuntimePlatform) {
    RuntimePlatform["browser"] = "browser";
    RuntimePlatform["webworker"] = "webworker";
    RuntimePlatform["other"] = "other";
})(RuntimePlatform || (RuntimePlatform = {}));
export function getRuntimePlatform() {
    if (
    //@ts-ignore
    "undefined" !== typeof WorkerGlobalScope &&
        "function" === typeof importScripts &&
        //@ts-ignore
        navigator instanceof WorkerNavigator) {
        return RuntimePlatform.webworker;
    }
    else if ("undefined" !== typeof navigator &&
        "undefined" !== typeof document) {
        return RuntimePlatform.browser;
    }
    else {
        return RuntimePlatform.other;
    }
}
//# sourceMappingURL=getRuntimePlatform.js.map